// extracted by mini-css-extract-plugin
module.exports = {"root":"footer-module--root--27XNt","pipe":"footer-module--pipe--1q1xs","holiday":"footer-module--holiday--k8VpD"};